// Generated by BUCKLESCRIPT VERSION 4.0.14, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");

var Curry = require("bs-platform/lib/js/curry.js");

function MakeGeneral(M) {
  var bind = M[
  /* bind */
  0];
  var $$return = M[
  /* return */
  2];
  var match = M[
  /* fmap */
  1];
  var fmap = typeof match === "number" ? function (f, m) {
    return Curry._2(M[
    /* bind */
    0], m, function (a) {
      return Curry._1(M[
      /* return */
      2], Curry._1(f, a));
    });
  } : match[1];
  var $great$great$eq = M[
  /* bind */
  0];

  var $less$$great = function $less$$great(m, f) {
    return Curry._2(fmap, f, m);
  };

  var join = function join(m) {
    return Curry._2($great$great$eq, m, function (a) {
      return a;
    });
  };

  var loop = function loop(vs, ms) {
    if (ms) {
      var ts = ms[1];
      return Curry._2($great$great$eq, ms[0], function (v) {
        return loop(
        /* :: */
        [v, vs], ts);
      });
    } else {
      return Curry._1($$return, List.rev(vs));
    }
  };

  var all = function all(ts) {
    return loop(
    /* [] */
    0, ts);
  };

  var all_ignore = function all_ignore(ms) {
    if (ms) {
      var ts = ms[1];
      return Curry._2($great$great$eq, ms[0], function (param) {
        return all_ignore(ts);
      });
    } else {
      return Curry._1($$return,
      /* () */
      0);
    }
  };

  return (
    /* module */
    [
    /* bind */
    bind,
    /* return */
    $$return,
    /* fmap */
    fmap,
    /* >>= */
    $great$great$eq,
    /* <$> */
    $less$$great,
    /* join */
    join,
    /* all */
    all,
    /* all_ignore */
    all_ignore]
  );
}

function MakeBasic(M) {
  var bind = M[0];
  var $$return = M[1];
  var fmap = M[2];
  var fmap$1 = typeof fmap === "number" ? function (f, m) {
    return Curry._2(bind, m, function (a) {
      return Curry._1($$return, Curry._1(f, a));
    });
  } : fmap[1];

  var $less$$great = function $less$$great(m, f) {
    return Curry._2(fmap$1, f, m);
  };

  var join = function join(m) {
    return Curry._2(bind, m, function (a) {
      return a;
    });
  };

  var loop = function loop(vs, ms) {
    if (ms) {
      var ts = ms[1];
      return Curry._2(bind, ms[0], function (v) {
        return loop(
        /* :: */
        [v, vs], ts);
      });
    } else {
      return Curry._1($$return, List.rev(vs));
    }
  };

  var all = function all(ts) {
    return loop(
    /* [] */
    0, ts);
  };

  var all_ignore = function all_ignore(ms) {
    if (ms) {
      var ts = ms[1];
      return Curry._2(bind, ms[0], function (param) {
        return all_ignore(ts);
      });
    } else {
      return Curry._1($$return,
      /* () */
      0);
    }
  };

  return (
    /* module */
    [
    /* bind */
    bind,
    /* return */
    $$return,
    /* fmap */
    fmap$1,
    /* >>= */
    bind,
    /* <$> */
    $less$$great,
    /* join */
    join,
    /* all */
    all,
    /* all_ignore */
    all_ignore]
  );
}

function MakeBasic2(M) {
  var bind = M[0];
  var $$return = M[1];
  var fmap = M[2];
  var fmap$1 = typeof fmap === "number" ? function (f, m) {
    return Curry._2(bind, m, function (a) {
      return Curry._1($$return, Curry._1(f, a));
    });
  } : fmap[1];

  var $less$$great = function $less$$great(m, f) {
    return Curry._2(fmap$1, f, m);
  };

  var join = function join(m) {
    return Curry._2(bind, m, function (a) {
      return a;
    });
  };

  var loop = function loop(vs, ms) {
    if (ms) {
      var ts = ms[1];
      return Curry._2(bind, ms[0], function (v) {
        return loop(
        /* :: */
        [v, vs], ts);
      });
    } else {
      return Curry._1($$return, List.rev(vs));
    }
  };

  var all = function all(ts) {
    return loop(
    /* [] */
    0, ts);
  };

  var all_ignore = function all_ignore(ms) {
    if (ms) {
      var ts = ms[1];
      return Curry._2(bind, ms[0], function (param) {
        return all_ignore(ts);
      });
    } else {
      return Curry._1($$return,
      /* () */
      0);
    }
  };

  return (
    /* module */
    [
    /* bind */
    bind,
    /* return */
    $$return,
    /* fmap */
    fmap$1,
    /* >>= */
    bind,
    /* <$> */
    $less$$great,
    /* join */
    join,
    /* all */
    all,
    /* all_ignore */
    all_ignore]
  );
}

exports.MakeGeneral = MakeGeneral;
exports.MakeBasic = MakeBasic;
exports.MakeBasic2 = MakeBasic2;
/* No side effect */